import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { RouteNavigation } from "../../../Routes";
import { useQuery } from "@tanstack/react-query";
import { GetAllAdvertisement } from "../../../lib/api";
import {
  ShowLoadingAnimation,
  ShowNoDataAnimation,
} from "../../../components/common/Animation";
import { FaRegEdit } from "react-icons/fa";
import { constant } from "../../../lib/constant";

const AdvertisementList = () => {
  const navigate = useNavigate();
  const { isLoading, isPending, isError, data } = useQuery({
    queryKey: ["GetAllAdvertisement"],
    queryFn: () => GetAllAdvertisement(),
    refetchInterval: 500,
  });
  console.log(data?.data,"data");
  

  const isAdvertisementData = data?.data;
  return (
    <div className="py-5">
      <h4 className="text-3xl font-bold mb-5">Advertisement List</h4>
      <div className="flex justify-end">
        <Link to={RouteNavigation.create_advertisement}>
          <button className="bg-gray-800 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
            Create New
          </button>
        </Link>
      </div>
      {isLoading || isPending ? (
        <div className="w-44 flex justify-center m-auto">
          <ShowLoadingAnimation />
        </div>
      ) : (
        <div className="w-full">
          <div className="mt-5 border-2 rounded-lg">
            <div className="overflow-auto">
              <TableContainer>
                <Table>
                  <TableHead className="bg-gray-800 rounded-xl">
                    <TableRow>
                      <TableCell style={{ color: "white" }}>
                        Advertisement Name
                      </TableCell>
                      <TableCell style={{ color: "white" }}>Preview</TableCell>
                      <TableCell style={{ color: "white" }}>Order</TableCell>
                      <TableCell style={{ color: "white" }}>
                        Department Name
                      </TableCell>
                      <TableCell style={{ color: "white" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  {!isPending && !isLoading && !isError && (
                    <TableBody>
                      {data?.data
                        ?.sort((a, b) => b.Status - a.Status)
                        .map((ad, index) => (
                          <TableRow key={index}>
                            <TableCell>{ad.AdvName}</TableCell>
                            <TableCell>
                              {ad.AdvFileUrl ? (
                                /\.(mp4|webm|ogg)$/i.test(ad.AdvFileUrl) ? (
                                  <video controls className="w-16 h-16">
                                    <source
                                      src={`${constant.image_render_url}${ad.AdvFileUrl}`}
                                      type={`video/${ad.AdvFileUrl.split(
                                        "."
                                      ).pop()}`}
                                    />
                                    Your browser does not support the video tag.
                                  </video>
                                ) : (
                                  <img
                                    className="w-16 h-16 object-contain"
                                    src={`${constant.image_render_url}${ad.AdvFileUrl}`}
                                    alt="preview"
                                  />
                                )
                              ) : null}
                            </TableCell>
                            <TableCell>{ad.AdvOrder}</TableCell>
                            <TableCell>{ad.DepName}</TableCell>
                            <TableCell
                              onClick={() => {
                                navigate("/create-advertisement", {
                                  state: { GetAdvertisement: ad },
                                });
                              }}
                            >
                              <div className="flex justify-center">
                                <FaRegEdit
                                  className="cursor-pointer"
                                  size={"20px"}
                                  color={ad.Status === true ? "green" : "red"}
                                />
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center">
        {isError ||
          (isAdvertisementData?.length === 0 && (
            <div className="w-44 flex justify-center">
              <ShowNoDataAnimation />
            </div>
          ))}
      </div>
    </div>
  );
};

export default AdvertisementList;
